


<video width="400" height="300" controls   class="video" (play)="video()" autoplay #videoPlayer>
    <source [src]= 'vidUrl|safe:"url"' type="video/mp4">
    Your browser does not support the video tag.
</video>


